<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <core-gamename :game="item.game" :collection="item.collection" class="name">

		<template v-if="isCondensed">&nbsp;&nbsp;-&nbsp;&nbsp;</template>

	</core-gamename>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed']

}

</script>

<style scoped>

.name {
	color: #333;
}

.is-desktop .name:hover {
	text-decoration: underline;
}

</style>